/**
 * @file getData.ts
 * Exports a method for fetching all data from the source JSON file.
 */
import { actionProps } from './dispatchAnswerSingle';

/**
 * Helper method that returns all data from the api file.
 *
 * Currently app data is stored in a JSON file. In the future this data may come
 * from an external API. The source data powers this app.
 *
 * @returns {Object}
 *   A JSON object of all app data.
 */
export default (action: actionProps): object => {
  // returning the data from api to update localStorage
  return action.data;
};
